<script>
import store from '@state/store'
import { format, parseISO } from 'date-fns/fp'

export default {
  name: 'NotificationsDrawer',
  props: {
    currentNotifications: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatNotificationDate(date) {
      return format('MMMM d, yyyy h:mma', parseISO(date))
    },
    showNotificationDrawer() {
      this.$emit('show-notification-settings')
    },
    setAllNotificationRead() {
      store.dispatch('auth/setAllNotificationRead')
    },
    setNotificationRead(notification) {
      store.dispatch('auth/setNotificationRead', {
        notificationId: notification.id,
      })
    },
  },
}
</script>

<template>
  <div
    class="fixed inset-x-0 z-20 w-full bg-gray-lighter inset-t-28 shadow-search"
  >
    <div class="w-content ml-26 pl-15 pr-40 mt-7.5 mb-4.5">
      <div class="flex items-center justify-between mb-3.5">
        <div class="mb-5 text-xl text-blue-darker">Notifications:</div>
        <ul class="flex items-center space-x-6">
          <li>
            <button
              class="block h-12 px-6 text-lg text-left button secondary-button"
              @click="setAllNotificationRead"
            >
              Mark all as read
            </button>
          </li>

          <li>
            <button
              class="block h-12 px-6 text-lg text-left button secondary-button"
              @click="showNotificationDrawer"
            >
              Settings
            </button>
          </li>
        </ul>
      </div>
      <div
        class="h-56 overflow-y-scroll bg-white border rounded-comments border-gray-light"
      >
        <ul class="divide-y divide-gray-dark-transparent">
          <li
            v-for="notification in currentNotifications"
            :key="notification.id"
            class=""
          >
            <a
              class="flex items-center px-6 py-3 hover:bg-blue-lighter"
              :class="{ 'bg-blue-lightest': !notification.read_at }"
              :href="notification.data.link"
              @click="setNotificationRead(notification)"
            >
              <div class="w-12 h-12 mr-3.5">
                <img
                  v-if="notification.data.author.pic"
                  :src="notification.data.author.pic"
                  class="inline-block object-cover w-full h-full rounded-full"
                  :alt="notification.data.author.name"
                />
              </div>

              <div>
                <strong
                  v-if="notification.data.author"
                  class="text-blue-darker mr-3.5"
                >
                  {{ notification.data.author.name }}
                </strong>
                <p class="leading-relaxed text-black">
                  {{ notification.data.message }}
                </p>
              </div>

              <time class="ml-auto font-hairline text-gray-light">
                {{ formatNotificationDate(notification.created_at) }}
              </time>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
